module.exports = __webpack_public_path__ + "static/media/bolt-alt.c9adfea7.svg";